import { render, staticRenderFns } from "./RegisterVenue.vue?vue&type=template&id=751aa9ab"
import script from "./RegisterVenue.vue?vue&type=script&lang=ts"
export * from "./RegisterVenue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports